import { render, staticRenderFns } from "./CustomerAccountForm.vue?vue&type=template&id=1ef27e46"
import script from "./CustomerAccountForm.vue?vue&type=script&lang=js"
export * from "./CustomerAccountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports